export default __webpack_public_path__ + "static/media/loading-icon.511dfdd8.png";